import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { PageName } from "#components";

export const Route = createFileRoute("/_authenticated/management/system-dashboard")({
  component: Component,
});

function Component() {
  const { t } = useTranslation();
  return (
    <main>
      <PageName>{t("%Dashboard.0%")}</PageName>
      <p>Reha3.0へようこそ。このページは準備中です。</p>
    </main>
  );
}
